<template lang="tr">
  <div lang="tr" class="vertical-align-step-0">
 
    <div v-if="mainPackage && mainPackage.id">
      <div @click="isSelectedMainPackage = !isSelectedMainPackage" class="box-border2 selectable-field"
        v-bind:class="{ 'selected': isSelectedMainPackage }">
        <div class="box-content-field">
          <div>
            
            <div class="new-product-top-field">
              <div class="new-product-top-field-inside">
                <div class="check-field" />
              
                <span class="new-product-name">{{getProductName(mainPackage)}}</span>
              </div>
              <div class="new-badge-field">{{ $t('Yeni Paket') }}</div> 

            </div>
          
          </div>
          <span class="new-product-description">{{getProductDescription(mainPackage)}}</span>

          <div class="">

            <ul
                  class="vertical-center features-spacing main-feature mt-4 features-half"
                >
                <li
                  v-for="feature in mainPackageFeatures"
                  :key="feature.text"
                  class="col-12"
          
                >
                  <span class="d-flex align-items-start feature-item">
                    <span  class="feature-text">{{ feature.text }}</span>
                    <i
                      v-if="feature.tooltipOptions"
                      v-tippy="feature.tooltipOptions.text"
                      class="fa fa-info-circle feature-icon"
                    ></i>
                  </span>

                </li>
              </ul>


          </div>

          <hr />

          <div class="new-product-bottom-field">
            <div class="bottom-left-field">
              <div class="old-price-field overline"> 
                <span class="old-price">{{formatPrice(898, mainPackage.currency)}} </span> 
                <span class="fee-text"> {{
                  mainPackage.type === 'subscription' ? (mainPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                }}{{'+'+$t('Kuruluş Harcı')}}</span>
              </div>
              <div class="new-price-field"> 
                <span class="new-price">{{ formatPrice(mainPackage.net_price,mainPackage.currency)}} </span> 
                <span class="fee-text">{{
                  mainPackage.type === 'subscription' ? (mainPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                }} {{' + '+$t('Kuruluş Harcı')}}</span>
              </div>
            </div>

            <div class="bottom-right-field">
              <div class="price-badge-field">
                <img src="/img/icons/lightning.svg" alt="price-badge" />
                <span class="ml-1">{{$t('daha tasarruflu', {price: '%28'})}}</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="additional-product mb-4" v-for="(product,index) in mainPackageChildProducts" :key="index">
        <span class="product-name-field">{{getProductName(product)}}</span>
        <div class="additional-product-right-field">
          <span class="price-text-field overline">{{formatPrice(product.net_price, product.currency)}}</span>
          <span class="colorful-text-field">{{$t('Vergi Paketi ile Ücretsiz')}}</span>
        </div>
      </div>

    <ukTaxConfirmationModal :features="ukTaxConfirmFeatures" @confirm="taxConfirmationConfirm" @cancel="taxConfirmationCancel"  ref="ukTaxConfirmationModal"/>
  </div>
</template>

<script>
/* eslint-disable camelcase */

import RegisterStore from '../../../stores/register';
import CompanyStore from '../../../stores/company';
import TokenStore from '../../../stores/token';
import ProductStore from '@/stores/product';
import ukTaxConfirmationModal from '../../modals/ukTaxConfirmation.vue';

export default {
  components: {
    ukTaxConfirmationModal,
  },
  data() {
    return {
      mainPackageChildCodes: ['UK_FORMATION_PACKAGE_PRODUCT'],
      modalTexts: {},
      title: '',
      productsCodes: ['UK_TAX_PACKAGE_PRODUCT', 'UK_FORMATION_PACKAGE_PRODUCT'],
      products: [],
      mainPackage: {},
      isSelectedMainPackage: false,
      callback: null,
      company: {
        global_activity_area: null,
      },
      mainPackageChildProducts: [],
      mainPackageFeatures: this.$t('Uk Tax Maddeleri'),
      ukTaxConfirmFeatures: this.$t('Uk Tax Confirmation Maddeleri'),
    };
  },
  async created() {
    this.startWaiting();
    $axios.all([this.getCompanyData(), this.getProductsData()]).then(
      $axios.spread((first_response, second_response, third_response) => {
        this.products = second_response.data.data;

        if (first_response && first_response.data.data.length) {
          this.company = first_response.data.data[0];
          this.$store.commit('setCompany', first_response.data.data[0]);

          const mainPackage = this.products.find((element) => element.code === this.productsCodes[0]);

          if (mainPackage) {
            this.mainPackage = mainPackage;
          }

          this.mainPackageChildProducts = this.mainPackageChildCodes
            .map((code) => this.products.find((item) => item.code === code))
            .filter((item) => item);

          if (this.company.package) {
            if (this.company.package.includes(this.productsCodes[0])) {
              this.isSelectedMainPackage = true;
            }
          }
          this.endWaiting();
        }
      })
    );
  },
  computed: {},
  methods: {
    taxConfirmationConfirm() {
      this.isSelectedMainPackage = true;
      this.sendForm();
    },
    taxConfirmationCancel() {
      this.sendForm();
    },
    getCompanyData() {
      return CompanyStore.dispatch('getCompany');
    },
    getProductsData() {
      return ProductStore.dispatch('getProductsByCodes', {
        codes: this.productsCodes,
        companyTypeId: 12,
        sort: true,
      });
    },

    openSummaryModal(callback) {
      this.callback = callback;
      if (!this.isSelectedMainPackage) {
        const element = this.$refs.ukTaxConfirmationModal.$el;
        $(element).modal('show');
      } else {
        this.sendForm();
      }
    },
    sendForm(callback) {
      let packageData = [];
      if (Array.isArray(this.company.package)) {
        packageData = [...this.company.package];
      }

      const removeArray = [this.mainPackage.code];

      packageData = packageData.filter((item) => !removeArray.includes(item));

      if (this.isSelectedMainPackage) {
        packageData.push(this.mainPackage.code);
      }

      this.startWaiting();

      RegisterStore.dispatch('package', {
        packages: packageData,
      }).then((s) => {
        this.$store.commit('setCompanyId', s.data.data.id);
        this.callback();
      });
    },
  },
};
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
